import { Text } from '@rneui/themed'
import { font } from 'app/theme'
import { StyleProp } from 'react-native'
import { TextStyle } from 'react-native/Libraries/StyleSheet/StyleSheetTypes'

interface TileItemDescriptionProps {
  description?: string
  error?: Error
  numberOfLines?: number
  textStyle: StyleProp<TextStyle>
}

export function TileItemDescription({
  description,
  error,
  numberOfLines,
  textStyle,
}: TileItemDescriptionProps) {
  return (
    <Text
      style={[textStyle, error && { fontFamily: font.italic }]}
      numberOfLines={numberOfLines}
    >
      {description}
    </Text>
  )
}
